import { apiSlice } from '../apiSlice';
import { CaseFilter, CasePageDTO } from '../DTO/case-management/caseDto';
import { Paginated, SuccessResponse } from '../DTO/common.interface';

export const caseApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getMyCaseList: builder.query<
			SuccessResponse<Paginated<CasePageDTO>>,
			CaseFilter
		>({
			query: (body) => ({
				url: `/web/case-management/my-case/${body.type}`,
				method: 'POST',
				body,
			}),
		}),
		getCentreCaseList: builder.query<
			SuccessResponse<Paginated<CasePageDTO>>,
			CaseFilter
		>({
			query: (body) => ({
				url: `/web/case-management/centre-case/${body.type}`,
				method: 'POST',
				body,
			}),
		}),
		getMyProgramList: builder.query<
			SuccessResponse<Paginated<CasePageDTO>>,
			CaseFilter
		>({
			query: (body) => ({
				url: `/web/case-management/my-program-member/${body.type}`,
				method: 'POST',
				body,
			}),
		}),
		getCentreProgramList: builder.query<
			SuccessResponse<Paginated<CasePageDTO>>,
			CaseFilter
		>({
			query: (body) => ({
				url: `/web/case-management/centre-program-member/${body.type}`,
				method: 'POST',
				body,
			}),
		}),
		getMyInterventionList: builder.query<
			SuccessResponse<Paginated<CasePageDTO>>,
			CaseFilter
		>({
			query: (body) => ({
				url: `/web/intervention/my-intervention/${body.type}`,
				method: 'POST',
				body,
			}),

			providesTags: ['MyInterventionList'],
		}),
		getCentreInterventionList: builder.query<
			SuccessResponse<Paginated<CasePageDTO>>,
			CaseFilter
		>({
			query: (body) => ({
				url: `/web/intervention/centre-intervention`,
				method: 'POST',
				body,
			}),
		}),
		getMemberInterventionList: builder.query<
			SuccessResponse<Paginated<CasePageDTO>>,
			CaseFilter
		>({
			query: (body) => ({
				url: `/web/intervention/${body.id}/page`,
				method: 'POST',
				body,
			}),

			providesTags: ['MyInterventionList'],
		}),
	}),
});

export const {
	useGetMyCaseListQuery,
	useGetCentreCaseListQuery,
	useGetMyProgramListQuery,
	useGetCentreProgramListQuery,
	useGetMyInterventionListQuery,
	useGetCentreInterventionListQuery,
	useGetMemberInterventionListQuery,
} = caseApi;
